import Vue from 'vue'
import Vuex from 'vuex'

// Import modules
import auth from './modules/auth'
import playlist from './modules/playlist'
import player from './modules/player'
import upload from './modules/upload'
import ui from './modules/ui'
import video from './modules/video'
import audioEffects from './modules/audioEffects'
import poll from './modules/poll'
import comments from './modules/comments'

// Import services
import AuthService from '@/services/AuthService'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    playlist,
    player,
    upload,
    ui,
    video,
    audioEffects,
    poll,
    comments
  }
})

// Set up auth state listener
AuthService.onAuthStateChanged(user => {
  // Reset superadmin status
  store.commit('auth/SET_IS_SUPER_ADMIN', false)
  
  // Update user in store
  store.dispatch('auth/setUserFromAuth', user)
  
  // Load appropriate playlist
  if (user) {
    // User is logged in
    if (!store.getters['playlist/playlistURL']) {
      store.dispatch('playlist/loadMasterPlaylist')
    } else {
      store.dispatch('playlist/loadPlaylist', store.getters['playlist/playlistID'])
    }
  } else {
    // User is logged out
    if (!store.getters['playlist/playlistURL']) {
      store.dispatch('playlist/loadDefaultPlaylist')
    } else {
      store.dispatch('playlist/loadPlaylist', store.getters['playlist/playlistID'])
    }
  }
})

export default store